<div class="modal-header">
  <h4 class="modal-title">Cambiar Solicitante</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="form-group">
    <label>Seleccionar Solicitante</label>
    <select class="form-control" [(ngModel)]="userId" (change)="onValueUserChange($event.target.value)">
      <option value="">Seleccione un solicitante</option>
      @for (user of users; track user) {
        <option [value]="user.id">
          {{user.name}} {{user.lastname}}
        </option>
      }
    </select>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.dismiss('Cancel click')">Cancelar</button>
  <button type="button" class="btn btn-primary" [disabled]="!isValidate || isSubmitting" (click)="saveDataToChangeRequester()">
    @if (!isSubmitting) {
      <span>Guardar</span>
    }
    @if (isSubmitting) {
      <span>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Guardando...
      </span>
    }
  </button>
</div>
